<template>
  <BaseDialog
    type="basic"
    :is-open="isOpen"
    :title="$t('settings.organizationTeams.rename')"
    class="md:w-110"
    @close="cancel"
  >
    <BaseInputField
      v-model="name"
      type="text"
      required
      :max-length="TEAM_NAME_MAX_LENGTH"
      :label="$t('settings.organizationTeams.name')"
      :error="nameError ?? ''"
    />
    <template #dismiss>
      <BaseTextButton color="text" @click="cancel">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
    <template #confirm>
      <BaseTextButton color="filled" @click="submit">{{ $t('common.save') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>
<script setup lang="ts">
  import { ref, watch } from 'vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseInputField from '@/core/components/base/form-fields/BaseInputField.vue'
  import { TEAM_NAME_MAX_LENGTH, teamNameErrorKey } from '../models/organization-team'

  interface Props {
    isOpen: boolean
    teamName: string
  }

  const props = defineProps<Props>()

  const emits = defineEmits<{
    (e: 'close'): void
    (e: 'rename', name: string): void
  }>()

  const name = ref<string>()
  const nameError = ref<string | null>(null)

  watch(name, () => {
    nameError.value = null
  })

  watch(
    () => props.isOpen,
    (isOpen) => {
      if (isOpen) {
        name.value = props.teamName
        nameError.value = null
      }
    },
  )

  const cancel = () => {
    emits('close')
  }

  const submit = () => {
    const errorKey = teamNameErrorKey(name.value ?? '')
    if (errorKey) {
      nameError.value = errorKey
      return
    }
    emits('rename', name.value!.trim())
  }

  const showInvalidName = () => {
    nameError.value = 'settings.organizationTeams.nameInvalid'
  }

  defineExpose({ showInvalidName })
</script>
